import React from 'react'

import HeaderContainer from '../../components/header/HeaderContainer'
import HeaderTitle from '../../components/header/HeaderTitle'
import HeaderContentSmall from '../../components/header/HeaderContentSmall'
import SubHeading from '../../components/inner/venderProduct/SubHeading'
import FullImage from '../../components/inner/venderProduct/FullImage'
import ImageTextPanel from '../../components/inner/technologies/ImageTextPanel'
import ThreeImagePanel from '../../components/inner/technologies/ThreeImagePanel'
import LastHeaderContentSmall from '../../components/header/LastHeaderContentSmall'

import AutomotiveImage02 from '../../assets/technologies/automotiveImage02.png'
import MedicalImage01 from '../../assets/technologies/medicalImage01.png';
import MedicalImage_02 from '../../assets/technologies/medicalImage_02.png'
import MedicalImage02 from '../../assets/technologies/medicalImage02.png';
import MedicalImage03 from '../../assets/technologies/medicalImage03.png';
import MedicalImage04 from '../../assets/technologies/medicalImage04.png';
import { useLanguage } from '../../context/LanguageContext';
import { siteCopy } from '../../i18n/landingCopy';

const Medical = () => {
  const { language } = useLanguage();
  const copy = siteCopy[language]?.pages?.technologies?.medical || siteCopy.en.pages.technologies.medical;

  const renderLines = (lines = []) =>
    lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));

  return (
    <HeaderContainer>
      <HeaderTitle>{copy.title}</HeaderTitle>
      <div style={{height: '60px'}}/>
      <HeaderContentSmall>
        {renderLines(copy.introParagraphs)}
      </HeaderContentSmall>

      <FullImage Item={MedicalImage01}/>
      <FullImage Item={MedicalImage_02}/>

      <ThreeImagePanel Image01={MedicalImage02} Image02={MedicalImage03} Image03={MedicalImage04}>
        <LastHeaderContentSmall>
          {renderLines(copy.threeImageText)}
        </LastHeaderContentSmall>
      </ThreeImagePanel>

      <SubHeading>{copy.solutionTitle}</SubHeading>
      <ImageTextPanel 
          Image={AutomotiveImage02}
          Title={copy.solution.title}
          Link={copy.solution.link}
          Text={<>{renderLines(copy.solution.text)}</>}/>

    </HeaderContainer>
  )
}

export default Medical
